import React from "react";
import Card from "components/card";
import { TrendingUp, TrendingDown } from "lucide-react";

const ProductivityEmployeeCard = ({
    initials,
    name,
    role,
    department,
    weekly_average,
    productivity_score,
    status,
    onClick,
    selected = false,
}) => {
    const isIncrease = status.toLowerCase().includes("increase");

    return (
        <Card
            hoverable
            onClick={onClick}
            className={`!rounded-2xl !border-2 transition-all duration-300 cursor-pointer ${
                selected
                    ? "!border-cyan-500  !bg-gradient-to-br from-cyan-50 to-blue-50 dark:from-cyan-900 dark:to-blue-900"
                    : "!border-slate-200 hover:!border-cyan-300 dark:bg-white/10"
                }`}
        >
            <div className="p-4 pb-6">
                <div className="flex items-start gap-3 mb-3">
                    <span 
                        className={`relative flex w-12 h-12 shrink-0 overflow-hidden rounded-full border-2 border-white shadow-md ${
                            selected
                                ? "bg-gradient-to-br from-cyan-500 to-blue-500"
                                : "bg-cyan-100"
                            }`}
                    >
                        <span className={`flex size-full items-center justify-center font-semibold ${
                            selected
                                ? "text-white"
                                : "text-cyan-700"
                            }`}
                        >
                            {initials}
                        </span>
                    </span>
                    <div className="flex-1 min-w-0">
                        <h4 className="font-semibold text-[14px] dark:text-white">
                            {name}
                        </h4>
                        <p className="text-[12px] text-slate-500">
                            {role}
                        </p>
                        <span
                            className={`status-indicator normal mt-1 text-[9px] ${
                                selected ? "bg-gradient-to-br from-cyan-50 to-blue-50" : "dark:text-white"
                            }`}
                        >
                            {department}
                        </span>
                    </div>
                </div>
                <hr className="border-t border-gray-200" />
                <div className="space-y-2">
                    <div className="flex items-center justify-between">
                        <span className="text-[11px] text-slate-500">
                            Weekly Avg
                        </span>
                        <span className=" text-[12px] font-semibold dark:text-white">
                            {weekly_average}h/day
                        </span>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-[11px] text-slate-500">
                            Productivity Score
                        </span>
                        <div className="flex items-center gap-1">
                            <span className="text-[12px] font-semibold dark:text-white">
                                {productivity_score}%
                            </span>
                            {isIncrease ? (
                                <TrendingUp className="w-4 h-4 text-green-600 dark:text-green-500" />
                            ) : (
                                <TrendingDown className="w-4 h-4 text-red-600 dark:text-red-500" />
                            )}
                        </div>
                    </div>
                    <div className="w-full h-2 rounded-full bg-emerald-100 overflow-hidden">
                        <div
                            className="h-full bg-emerald-500"
                            style={{ width: `${productivity_score}%` }}
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ProductivityEmployeeCard;